<script>
import { Doughnut } from 'vue-chartjs';

export default {
  extends: Doughnut,
  props: {
    accepted: {
      type: Number,
    },
    pending: {
      type: Number,
    },
    rejected: {
      type: Number,
    },
  },
  mounted() {
    // Overwriting base render method with actual data.
    this.renderChart({
      datasets: [{
        data: [this.accepted, this.pending, this.rejected],
        backgroundColor: [
          '#98CCFF',
          '#FFE796',
          '#FA5A56',
        ],
        borderWidth: 0,
      }],
    }, {
      legend: {
        display: false,
      },
      tooltips: {
        enabled: false,
      },
      cutoutPercentage: 85,
    });
  },
};
</script>
